import { ClaimDetailTimeline } from '@/components/Domains/Claims/Views/ClaimDetailTimeline'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/timeline')({
  component: ClaimDetailTimeline,
})
